import React, {Component} from "react";

/*
* Authentication
*/
import Alt from 'alt';
import history from '../../history';
import axios from 'axios';
import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';
import routes from '../../routes';

import DashboardAdmin from './admin/DashboardAdmin';
import DashboardDoctor from './doctor/DashboardDoctor';
import DashboardClient from './client/DashboardClient';

import {
    Row,
    Col,
    Button,
    Label,
    Input
} from "reactstrap";

class Dashboard extends Component {

    render() {

      return(
          <div className="h-100">

          {{
          "M": (
            <DashboardDoctor />
          ),
          "C": (
            <DashboardClient />
          ),
          "A": (
            <DashboardAdmin />
          )
          }[AuthStore.getState().user.profile]}

          </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js